
import axios from "axios";

let url = process.env.NODE_ENV !== 'development'? `https://bot-platform.amu.kz/api`: `http://bot.loc/api`;
const axiosClient = axios.create({
  baseURL: url
})


axiosClient.interceptors.response.use(response => {
  return response;
}, error => {
  throw error;
})

export default axiosClient;
